import { getLinks } from "@cinch-nx/data-storyblok";
import { tagError } from "@core/datadog-server";
function createStaticPaths(links) {
    const paths = [];
    for (const link of Object.values(links)){
        // should look like /car-reviews-v2/ford/focus/2022
        const [, make, model, slug] = link.slug.split("/");
        // if it does not match, we don't want it
        if (make !== undefined && model !== undefined && slug !== undefined) {
            paths.push({
                params: {
                    make,
                    model,
                    slug
                }
            });
        }
    }
    return paths;
}
export const getStaticPaths = async ()=>{
    // Get the paths we want to pre-render based on data
    try {
        const links = await getLinks("car-reviews-v2/");
        const paths = createStaticPaths(links);
        return {
            paths,
            fallback: "blocking"
        };
    } catch (error) {
        console.error(`Error fetching links for car-reviews-v2: ${error}`);
        if (error instanceof Error || typeof error === "string") {
            tagError(error);
        }
        return {
            paths: [],
            fallback: "blocking"
        };
    }
};
